import { Fragment } from 'react';
import { tv } from '../_lib/utils';
import { Avatar, type AvatarProps } from '../Avatar';
import { Tooltip } from '../Tooltip';

const styles = tv({
	slots: {
		base: 'group/avatarGroup inline-flex',
		avatar: 'transition-all duration-normal ease-smooth first:ml-0!',
	},
	variants: {
		size: {
			xs: {
				avatar: '-ml-3 group-hover/avatarGroup:-ml-2',
			},
			sm: {
				avatar: '-ml-4 group-hover/avatarGroup:-ml-2',
			},
			md: {
				avatar: '-ml-5 group-hover/avatarGroup:-ml-2',
			},
			lg: {
				avatar: '-ml-5 sm:-ml-6 group-hover/avatarGroup:-ml-3',
			},
			xl: {
				avatar: '-ml-6 sm:-ml-7 group-hover/avatarGroup:-ml-3',
			},
			'2xl': {
				avatar: '-ml-7 sm:-ml-8 group-hover/avatarGroup:-ml-4',
			},
			'3xl': {
				avatar: '-ml-8 sm:-ml-10 group-hover/avatarGroup:-ml-5',
			},
		},
	},
});

type AvatarItemProps = AvatarProps & {
	name: string;
};

export type AvatarGroupProps = {
	className?: string;
	items: AvatarItemProps[];
	size?: AvatarProps['size'];
};

export function AvatarGroup(props: AvatarGroupProps) {
	const size = props.size || '3xl';
	const { base, avatar } = styles({ size });

	return (
		<div className={base({ className: props.className })} data-component='AvatarGroup'>
			{props.items.map((item, index) => {
				return (
					<Fragment key={`${index}-${item.name?.slice(0, 10)}`}>
						<Tooltip
							className={avatar()}
							trigger={
								<button className={`rounded-full outline-hidden!`} style={{ zIndex: props.items.length - index }} tabIndex={-1}>
									<Avatar {...item} className={`border border-black/10`} key={`avatar-group-${index}`} size={size} />
								</button>
							}
							text={item.name}
						/>
					</Fragment>
				);
			})}
		</div>
	);
}
